// @ts-nocheck

import { forEach } from 'lodash'
import PropTypes from 'prop-types'
import SwitchField from '../../../fields/types/SwitchField'

interface FreeTextSwitchFieldProps {
  formState: Record<string, any>
  setFormField: (key: string, value: any) => void
  setFormState: (key: string, value: any) => void
  values: Record<string, any>
  testId?: string
}

/**
 * @description Switch Field for Free Text in the Add Medication modal.
 * Used in the Med Rounds Field Table Header to allow entering
 * free text for the dose.
 * @param {FreeTextSwitchFieldProps} props - The component's props.
 * @returns {JSX.Element} FreeTextSwitchField.
 */
export default function FreeTextSwitchField(
  props: FreeTextSwitchFieldProps
): JSX.Element {
  const { formState, setFormField, setFormState, values, testId } = props
  const { defaultQuantityType } = formState
  const { emarRoundsDetails } = values

  const label = (
    <div
      style={styles.fieldLabel}
      data-testid={testId ? `${testId}-free-text-label` : 'free-text-label'}
    >
      Free text
    </div>
  )

  const handleChange = ({ key, value, defaultQuantityType, rounds }: any) => {
    setFormState({ key, value: !!value })
    setFormState({ key: 'hasAltDose', value: false })

    // Clears all doses and altDoses when switch is turned on or off
    forEach(rounds, (round, index) => {
      if (round.isChecked) {
        setFormField({ key: `emarRoundsDetails[${index}].dose`, value: null })
        setFormField({
          key: `emarRoundsDetails[${index}].altDose`,
          value: null
        })
      }
    })

    if (value) {
      setFormState({ key: 'quantityTypePrePopped', value: false })
      setFormField({ key: 'quantityType', value: null })
      setFormField({ key: 'stockQuantityType', value: null })
    } else {
      setFormState({
        key: 'quantityTypePrePopped',
        value: !!defaultQuantityType
      })
      setFormField({ key: 'quantityType', value: defaultQuantityType })
    }
  }

  return (
    <div
      data-testid={
        testId ? `${testId}-free-text-switch-field` : 'free-text-switch-field'
      }
    >
      <SwitchField
        label={label}
        labelNote="Write anything you want. No units attached. N.B. If you use free text, we won't be able to work out expected stock."
        labelStyle={styles.freeTextLabel}
        formKey="freeTextDose"
        onChange={({ key, value }) =>
          handleChange({
            key,
            value,
            defaultQuantityType,
            rounds: emarRoundsDetails
          })
        }
        style={styles.freeTextField}
        values={formState}
      />
    </div>
  )
}

FreeTextSwitchField.propTypes = {
  formState: PropTypes.object.isRequired,
  setFormField: PropTypes.func.isRequired,
  setFormState: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  testId: PropTypes.string
}

const styles = {
  fieldLabel: {
    fontWeight: 400
  },
  freeTextField: {
    flex: '0.5 1 0%'
  },
  freeTextLabel: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 11
  }
}
